'use strict';

exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// this is a common superclass that provides a namedMethod interface for particular data providers to implement by extending from this class.
// this class is never newed up, it is only used to extend from
//
//
// the decision of what parameters are to be passed in is an implementation detail made at the particular platform level
//      sub classes (ie, localyticsDataHandler, GooglTagManagerDataHandler, ...) within a particular platform/app that extend
//      from this base data handler are responsible for a consistent parameter API for these methods

// Example:
//
// myReactComponent.jsx in Order
//
//  import AnalyticsManager from 'common-web.lib.analyticsManager';
//
//  onSubmitOrderSuccess() {
//      doApplicationThings();
//      AnalyticsManager.trackPurchase(state);
//  }
//
// myReactComponent.jsx in Kiosk
//
//  import AnalyticsManager from 'common-web.lib.analyticsManager';
//
//  onSubmitOrderSuccess() {
//      doApplicationThings();
//      AnalyticsManager.trackPurchase(cart, menu, currencyCode);
//  }
//
// END EXAMPLE
//
// Note that all data handlers registered in a specific platform must use the same parameter API on AnalyticsManager methods
//      In the example above, Kiosk dataHandlers gets references to cart, menu, and currencyCode passed into their trackPurchase
//      In the example above, Order dataHandlers get a reference to state passed into their trackPurchase

// avoids linting errors
var doNothing = function doNothing(params) {
    return params;
};

var BaseAnalyticsDataHandler = function () {
    function BaseAnalyticsDataHandler() {
        _classCallCheck(this, BaseAnalyticsDataHandler);
    }

    BaseAnalyticsDataHandler.prototype._sendData = function _sendData(data) {
        doNothing(data);
    };

    BaseAnalyticsDataHandler.prototype.trackManualOfferRedemption = function trackManualOfferRedemption(params) {
        doNothing(params);
    };

    BaseAnalyticsDataHandler.prototype.trackDigitalOfferRedemption = function trackDigitalOfferRedemption(params) {
        doNothing(params);
    };

    BaseAnalyticsDataHandler.prototype.trackPurchase = function trackPurchase(payload) {
        doNothing(payload);
    };

    // REMOVE after all dependent sites are updated to utilize the latest refactor - here for backwards compatibility


    BaseAnalyticsDataHandler.prototype.sendPurchaseEvent = function sendPurchaseEvent(payload) {
        doNothing(payload);
    };

    BaseAnalyticsDataHandler.prototype.trackCheckoutStep = function trackCheckoutStep(params) {
        doNothing(params);
    };

    BaseAnalyticsDataHandler.prototype.trackCheckoutOption = function trackCheckoutOption(params) {
        doNothing(params);
    };

    // ... add more methods here


    return BaseAnalyticsDataHandler;
}();

exports.default = BaseAnalyticsDataHandler;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/analytics/AnalyticsManager/BaseAnalyticsDataHandler.js
// module id = 212
// module chunks = 0